import { Component, OnInit, ViewChild, ViewChildren, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router' ;

import { ApiService, DialogsService, FilterService } from '../../custom-material/Services/';
import { UserModel, SocietyModel, BuildingModel, DiagnosticModel, QuestionnaryModel, AnswerModel } from '../../main/Models/';
import { SynthesisModel } from './synthesis.model';

import { BuildingChooseComponent } from '../../main/Components/building-choose/building-choose.component';
import { PiechartComponent } from '../piechart/piechart.component';
import {Colors} from '../../main/Models/colors';
import { globalData, selectionObserver } from 'src/app/main/Models/global.model';
import { toollist } from './synthesis.tool';

@Component({
  selector: 'app-synthesis',
  templateUrl: './t_synthesis.component.html',
  styleUrls: ['./synthesis.component.less']
})
export class SynthesisComponent implements OnInit, selectionObserver {

  //@ViewChild('bchooser') buildingChooser: BuildingChooseComponent;
  @ViewChild('piechart') piechart: PiechartComponent;

  society: SocietyModel;
  buildings: Array<BuildingModel> = [];
  questionnaries: Array<QuestionnaryModel> = [];
  
  allDiagnostics: Array<SynthesisModel> = [];
  noDiagnosticFound:boolean = false;
  showResults: boolean = false;
  filterService: FilterService = new FilterService([]);
  
  
  currentIdquest = 0;
  set _currentIdquest(ID: number) {
    this.currentIdquest = ID;
    this.currentQuestName = this.questionnaries.filter((q: QuestionnaryModel) => q.id === ID)[0].name;

    this.loadDiagnostics(ID);
  }
  get _currentIdquest(): number
  {
    return this.currentIdquest;
  }

  currentQuestName = '';

  @ViewChild('piechart') chart: PiechartComponent;

  showManual: boolean = false;
  toggleManual() { this.showManual = !this.showManual; }

  constructor(
    private dialogService: DialogsService,
    private apiService: ApiService,
    private router: Router,
    public gd: globalData
    ) {
      this.gd.headerTitle = "Synthèse des audits";
      this.gd.headerIcon = "pie_chart";
      this.gd.toollist = toollist;
      this.gd.toolService = this;
      this.gd.showChooser = true;
  }

  ngOnInit(): void
  {
    this.loadSocietyQuestionnaries();
    this.gd.subscribe(this);
  }

  ngOnDestroy()
  {
    this.gd.unsubscribe(this);
  }

  loadSocietyQuestionnaries(): void
  {
    this.questionnaries = [];
    const params = this.apiService.createParams(
                    {society: this.apiService.connectedUser.society.id});
    this.apiService.getAllFromServer('questionnary', params)
      .then((response: any) => {
        for ( const q of response) {
            this.questionnaries.push(new QuestionnaryModel(q));
          }
      });
  }

  loadDiagnostics(IDquestionnnary): void
  {
    this.showResults = false;
    this.filterService.setData([]);
    if (!IDquestionnnary) return;

    const params = this.apiService.createParams({
      questionnary_id: IDquestionnnary,
      buildings: this.gd.buildingsList
    });
    this.apiService.getFromServer('synthesis', params)
     .then(s => s.subscribe((response: any) => {
      
      this.noDiagnosticFound = (response._embedded.synthesis[0].length==0);
      if(this.noDiagnosticFound) return;

      this.allDiagnostics = [];
       response._embedded.synthesis[0].forEach((s: object) => {
         this.allDiagnostics.push(new SynthesisModel(s) );
       });
       this.filterService.setData(this.allDiagnostics);
       setTimeout(()=>{this.buildingsSelectionChanged()}, 0);
     }));
  }
  reloadDiagnostics(): void
  {
    this.loadDiagnostics(this.currentIdquest);
  }

  getColor(note): string
  {
    if (note < 6) { return Colors.colors[0]; }
    else if (note <= 10) { return  Colors.colors[1]; }
    else if (note <= 14) { return Colors.colors[2]; }
    else { return Colors.colors[3]; }
  }

  get notes(): any[]
  {
    return this.filterService.showedData.map((diagnostic) => diagnostic.lastNote);
  }


  buildingsSelectionChanged() {
    if(this.filterService.origData.length==0) return;
    this.filterService.filterBy('id_building', this.gd.selectedBuildingsList);
    setTimeout(()=>{
      this.piechart.notes = this.notes;
      this.piechart.calculateData();
    }, 0);
    setTimeout(()=>{
      this.showResults = true;
    }, 50);
  }

  filterBy(prop, value, keepResults=false)
  {
    this.showResults = keepResults;
    this.filterService.filterBy(prop, value);
    setTimeout(()=>{
      this.piechart.notes = this.notes;
      this.piechart.calculateData();
    }, 0);
    setTimeout(()=>{
      this.showResults = true;
    }, 50);
  }

}
